/* eslint-disable no-param-reassign */
import $ from 'jquery';
import { http } from '@bingads-webui/http-util';

const checkFrequencyInMinutes = 120; // 2 hours

// max count is 1 week.
// 7 * 24 = 168 hours.
// 168 * 60 = 10080 minutes.
// 10080 / 120 = 84 requests every 2 hours.
const autoRefreshTokenMaxCount = 10080 / checkFrequencyInMinutes;

const WorkerBlob = URL.createObjectURL(new Blob(
  [
    '(',
    // eslint-disable-next-line func-names
    function () {
      onmessage = function (e) {
        const url = e.data[0];
        const checkFrequency = e.data[1];
        const autoRefreshTokenMaxCountInternal = e.data[2];
        const sessionId = e.data[3];

        let lastRefreshTimestamp = Date.now();

        let autoRefreshTokenCounter = 0;

        setInterval(() => {
          const xhr = new XMLHttpRequest();

          xhr.open('GET', url, true);
          xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
          xhr.setRequestHeader('x-ms-sessionid', sessionId);

          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
              autoRefreshTokenCounter += 1;
              lastRefreshTimestamp = Date.now();

              postMessage([JSON.parse(xhr.responseText)]);
            }
          };

          if (autoRefreshTokenCounter <= autoRefreshTokenMaxCountInternal) {
            const currentTime = Date.now();

            // get the hours difference between last successful refresh and current time.
            const hoursDiff = Math.abs(currentTime - lastRefreshTimestamp) / (60 * 60 * 1000);
            if (hoursDiff < 24) {
              xhr.send();
            }
          }
        }, checkFrequency);
      };
    }.toString(),
    ')()',
  ],
  { type: 'application/javascript' }
));

const updateContexts = ({
  newSmallToken,
  serverContext,
  config,
  pageContext,
  setNewServerContext,
}) => {
  serverContext.Token = newSmallToken;
  config.set('Token', newSmallToken);
  config.set('odata.token', newSmallToken);
  pageContext.Token = newSmallToken;

  if (window.campaignODataConfigs) {
    window.campaignODataConfigs.Token = newSmallToken;
  }

  if (setNewServerContext) {
    setNewServerContext(newSmallToken);
  }
};

export class AutoRefreshToken {
  constructor({
    serverContext,
    setNewServerContext,
    PageContext,
    config,
    appActivity,
  }) {
    this.http = http;
    this.autoRefreshTaskWorker = null;
    this.autoRefreshTokenCounter = 0;
    this.checkFrequency = checkFrequencyInMinutes * 1000 * 60;
    this.url = `${window.location.origin}/campaign/pagecontext/refreshsmalltokenandupdatecookie${window.location.search}`;
    this.serverContext = serverContext;
    this.setNewServerContext = setNewServerContext;
    this.PageContext = PageContext;
    this.config = config;
    this.appActivity = appActivity;
    this.lastRefreshTimestamp = Date.now();

    if (window.Worker) {
      this.autoRefreshTaskWorker = new Worker(WorkerBlob);
    }
  }

  start() {
    if (this.autoRefreshTaskWorker) {
      this.autoRefreshTaskWorker.postMessage([
        this.url,
        this.checkFrequency,
        autoRefreshTokenMaxCount,
        this.PageContext.sessionId,
      ]);

      this.autoRefreshTaskWorker.onmessage = (e) => {
        if (e.data[0]) {
          this.appActivity.trace(`AutoRefreshToken received current token: ${e.data[0].Token}...`, 'auto-refresh-token');

          const token = e.data[0].Token;
          const currentAutoRefreshTokenCount = e.data[1];

          updateContexts({
            newSmallToken: token,
            serverContext: this.serverContext,
            pageContext: this.PageContext,
            config: this.config,
            setNewServerContext: this.setNewServerContext,
          });

          if (currentAutoRefreshTokenCount > autoRefreshTokenMaxCount) {
            this.stop();
          }
        } else {
          this.appActivity.trace('AutoRefreshToken received undefined for Token', 'auto-refresh-token');
        }
      };
    } else {
      this.appActivity.trace('AutoRefreshToken cannot start since web worker is unavailable', 'auto-refresh-token');
      this.stop();
    }

    $(window).on('unload', () => this.stop());
  }

  stop() {
    if (this.autoRefreshTaskWorker !== null) {
      this.autoRefreshTaskWorker.terminate();
      this.autoRefreshTaskWorker = null;
    }
  }

  refresh() {
    this.autoRefreshTokenCounter = 0;
  }
}

export const autoRefreshTokenInstance = new AutoRefreshToken({});
